import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { dismissReport } from "../../actions/ui_actions";
import _ from "lodash";
import { Box } from "reflexbox";
import {
  CommandBarButton,
  PrimaryButton
} from "office-ui-fabric-react/lib/Button";
import { Modal } from "office-ui-fabric-react/lib/Modal";

class LoadingList extends Component {
  _print = () => {
    let printContents = document.getElementById("printable").innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    this.props.dismiss();
    window.location.replace("/planning");
  };

  render() {
    const { shipment } = this.props;
    const plate =
      shipment && shipment.carrierByCarrierId
        ? shipment.carrierByCarrierId.truck +
          "-" +
          shipment.carrierByCarrierId.trailer
        : "";

    const sortedData = _.orderBy(this.props.items, ["loadingOrder"], ["asc"]);

    const data = _.chain(sortedData)
      .groupBy("relationByLoadAtId.id")
      .map((value, key) => {
        return {
          id: key,
          name: value[0].relationByLoadAtId.name,
          doorCode: value[0].relationByLoadAtId.doorCode,
          loadingAddr: value[0].relationByLoadAtId.loadingAddr,
          loadingRoute: value[0].relationByLoadAtId.loadingRoute,
          value
        };
      })
      .value();

    return (
      <Modal
        isOpen={this.props.visible}
        onDismiss={this.props.dismiss}
        isBlocking={false}
        containerClassName="ms-modalExample-container"
      >
        <Box p={2} style={{ width: "80vw", height: "80vh" }}>
          <div>
            <PrimaryButton text="Print" onClick={this._print} />
            <PrimaryButton
              style={{ marginLeft: "5px" }}
              text="Close"
              onClick={this.props.dismiss}
            />
          </div>

          <Box id="printable">
            <h4>Дата загрузки: {shipment && shipment.date}</h4>
            <h4>Загрузочный лист трака: {plate}</h4>
            {shipment &&
              shipment.carrierByCarrierId && (
                <div>
                  <h5>tel: {shipment.carrierByCarrierId.driver1Tel}</h5>
                  <h5>tel: {shipment.carrierByCarrierId.driver2Tel}</h5>
                </div>
              )}
            <hr />
            {data &&
              _.map(data, (orders, key) => (
                <div key={key}>
                  <h5>Фирма: {orders.name}</h5>
                  <h5>Адрес: {orders.loadingAddr}</h5>
                  <h5>Как проехать: {orders.loadingRoute}</h5>
                  <h5>Код двери: {orders.doorCode}</h5>
                  <table className="pt-table pt-bordered">
                    <thead>
                      <tr>
                        <td>Кол-во мест</td>
                        <td>Кол-во палет</td>
                        <td>Код упаковки</td>
                        <td>Тип упаковки</td>
                        <td>Тип груза</td>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.value &&
                        _.map(orders.value, (order, k) => (
                          <tr key={k}>
                            <td>{order.boxes}</td>
                            <td>{order.amountPallets}</td>
                            <td>{order.packingCode && order.packingCode}</td>
                            <td>
                              {order.packingTypeByPackingId &&
                                order.packingTypeByPackingId.type.toUpperCase()}
                            </td>
                            <td>
                              {order.cargoTypeByCargoTypeId &&
                                order.cargoTypeByCargoTypeId.type}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Всего</td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr />
                </div>
              ))}
          </Box>
        </Box>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    items: state.ui.reportItems,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, { dismiss: dismissReport })(
  LoadingList
);



// WEBPACK FOOTER //
// ./src/views/Reports/_LoadingList.js